import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchCenterInitiatedRepatriationsTransactionsCreate = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'createCenterInitiatedRepatriationsTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    departureDateTime: moment(payload.params.departureDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
    description: payload.params.description,
    inboundImpc: payload.params.inboundImpc,
    inboundOperator: payload.params.inboundOperator,
    outboundImpc: payload.params.outboundImpc,
    outboundOperator: payload.params.outboundOperator,
    plannedArrivalDateTime: moment(payload.params.plannedArrivalDateTime).set({ second: 0 }).format('YYYY-MM-DD HH:mm:ss'),
    quantity: payload.params.quantity,
  });
};

export default apiFetchCenterInitiatedRepatriationsTransactionsCreate;
